import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h48v48H0z"
}), React.createElement("path", {
  d: "M23.988 0c5.035 0 8.526 2.645 10.412 6.6l5.055 1.264A6 6 0 0144 13.684V42a6 6 0 01-6 6H10a6 6 0 01-6-6V13.685a6 6 0 014.545-5.821l5.072-1.269C15.504 2.643 18.985 0 23.988 0zM12.243 11.063l-2.728.681A2 2 0 008 13.684V42a2 2 0 002 2h28a2 2 0 002-2V13.685a2 2 0 00-1.515-1.94l-2.714-.68C36.744 16.917 35.193 24.09 31 30l-7-8-7 8c-4.197-5.91-5.737-13.086-4.757-18.937zM24 36a2 2 0 110 4 2 2 0 010-4zm0-8a2 2 0 110 4 2 2 0 010-4zm-.004-24C13.496 4 16.5 17.5 24 22c7.5-4.5 10.496-18-.004-18z",
  fill: "#262626"
}));

var SvgAddOnLaundryXLarge = function SvgAddOnLaundryXLarge(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgAddOnLaundryXLarge;